/*********************************************************************************************
 * COOKIES - Rouvre le widget Axeptio depuis un lien
 *
 * Tout lien dont l'URL finit par #cookies (ex. lien de menu BO
 * /policies/privacy-policy#cookies) ouvre le panneau Axeptio. openAxeptioCookies
 * est expose par le SDK que charge l'app embed Axeptio : s'il est absent (embed
 * desactive, SDK bloque), le lien navigue normalement vers sa page.
 */
document.addEventListener('click', (e) => {
	const link = e.target.closest('a[href$="#cookies"]');
	if (!link || typeof window.openAxeptioCookies !== 'function') return;

	e.preventDefault();
	window.openAxeptioCookies();
});
